/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 * Author: Thomas Barry
 *
 * Description: The WFUI-Digital-Core library exposes a common navigation API that is implemented by
 * consuming frameworks. This module registers DBD-React-UI's navigation API with WFUI-Digital-Core.
 */
import { registerNavigationAPI } from 'wfui-digital-core/es/lib';
import NavigationItemRecord from '../records/NavigationItemRecord';
import { getStore } from '../store/store';
import { requestNavigation } from '../store/navigation/actions';

var navigate = function navigate(_ref) {
  var navigationUrl = _ref.navigationUrl,
      displayType = _ref.displayType;
  var navigationItem = new NavigationItemRecord({
    navigationUrl: navigationUrl,
    displayType: displayType
  });
  getStore().dispatch(requestNavigation(navigationItem.toJS()));
};

registerNavigationAPI(navigate);